export { SwimmingIcon } from './SwimmingIcon'
